<app-admin-sidebar></app-admin-sidebar>
<app-adminheader></app-adminheader>

<div class="dash">
  <div class="driver-acoordion">
    <div class="dash-drivers-top1">
      <a [ngClass]="{ active: selectedFilter === 'all' }" (click)="setFilter('all')">All</a>
      <a [ngClass]="{ active: selectedFilter === 'sent' }" (click)="setFilter('sent')">Sent</a>
      <a [ngClass]="{ active: selectedFilter === 'draft' }" (click)="setFilter('draft')">Draft</a>
    </div>
    <div class="dash-drivers-top2">
      <button type="button" class="button buttonBlue fixed-btn" (click)="openAddDialog()">
        <img class="drivers-head-img" src="../../../assets/img/plus-white.svg" />
        Add Notification
      </button>
    </div>
  </div>

  <div class="notifications-list p-3">
    <div [class.spinner]="loading"></div>
    <div class="row m-0">
      <div class="col-xl-3 col-lg-4 col-md-6 col-sm-12 mb-4 px-2" *ngFor="let notif of filteredNotifications">
        <div class="card notification-card shadow-sm h-100">
          <div class="card-header d-flex justify-content-between align-items-center">
            <span class="badge" [ngClass]="{'badge-success': notif.is_active, 'badge-warning': !notif.is_active}">
              {{ notif.is_active ? 'Sent' : 'Draft' }}
            </span>
            <span class="text-muted small">{{ notif.schedule_at | date:'dd-MM-yyyy' }}</span>
          </div>

          <img *ngIf="notif.image_url" [src]="notif.image_url" class="card-img-top banner-img" alt="Banner Image">

          <div class="card-body d-flex flex-column">
            <div class="action-details bg-light p-2 rounded mb-3">
              <h5 class="card-title mb-1">{{ notif.title }}</h5>
              <p class="text-truncate card-text text-muted mb-0">{{ notif.body }}</p>
            </div>

            <div class="mb-3 small flex-grow-1">
              <div class="mb-1"><strong>CTA:</strong> {{ notif.cta_text }}</div>
              <div class="text-truncate" title="{{ notif.deep_link }}"><strong>Link:</strong> {{ notif.deep_link }}</div>
            </div>

            <div class="card-actions d-flex justify-content-between mt-auto">
              <div class="d-flex" style="gap: 8px;">
                <button class="card-btn edit-btn" (click)="openAddDialog(notif)">
                  <img src="../../../assets/img/edit.svg" style="height:12px; margin-right:4px;" />
                  Edit
                </button>
                <button class="card-btn delete-btn" (click)="deleteNotification(notif)">
                  <img src="../../../assets/img/delete.svg" style="height:12px; margin-right:4px;" />
                  Delete
                </button>
              </div>
              <button class="card-btn send-btn" (click)="sendNotification(notif)">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style="height:13px; margin-right:5px;"><path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/></svg>
                Send
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 text-center py-5" *ngIf="filteredNotifications.length === 0 && !loading">
        <h4 class="text-muted">No notifications found.</h4>
        <p>Click 'Add' to create a new campaign.</p>
      </div>
    </div>
  </div>
  <div *ngIf="paginationNotifications">
    <div *ngIf="last_page && last_page > 1" class="pagination">
      <button
        class="btn"
        [disabled]="fetch_page == 1"
        (click)="pagination('-1')"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="btn--icon"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M15 19l-7-7 7-7"
          />
        </svg>
      </button>
      <button
        class="btn"
        [disabled]="fetch_page == 1"
        (click)="pagination('first')"
      >
        <img
          src="../../../assets/img/pagination-left.svg"
          alt=""
          class="btn--icon"
        />
      </button>
      <div class="pages">
        <a class="page" *ngIf="fetch_page > 0">{{ fetch_page }}</a>
      </div>
      <button
        class="btn"
        [disabled]="last_page == fetch_page"
        (click)="pagination('last')"
      >
        <img
          src="../../../assets/img/pagination-right.svg"
          alt=""
          class="btn--icon"
        />
      </button>
      <button
        class="btn"
        [disabled]="last_page == fetch_page"
        (click)="pagination('1')"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="btn--icon"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
        >
          <path
            stroke-linecap=" round"
            stroke-linejoin="round"
            d="M9 5l7 7-7 7"
          />
        </svg>
      </button>
    </div>
  </div>
</div>
